<template src="./AddUpdateSpeedLimit.html"></template>
<script>
import Vue from "vue";
import { notifyError, notifyWarn } from "@/utils/notification-helper";
import { Grid } from "@progress/kendo-vue-grid";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("settings");
import fileUploadCell from "@/components/FileUploadCell/FileUploadCell.vue";
import $ from "jquery";
import FormGenerator from "@/components/Fields/FormGenerator";
Vue.component("Grid", Grid);
import { BTabs } from "bootstrap-vue";
import DialogBox from "@/components/DialogBox";
Vue.component("b-tabs", BTabs);
export default {
  components: {
    FormGenerator,
    DialogBox,
  },
  data: function () {
    return {
      gridHeight: window.innerHeight - 180,
      vehicleData: {},
      vehicleSpeedLimit: {},
      editField: false,
      editId: null,
      items: [],
      open: false,
      dataItems: [],
      vehicleType: "",
      vehicleTypes: [],
      highSpeed: null,
      safeSpeed: null,
      vehicleTypeId: null,
      vehicleNumberInvalid: null,
      FileUploadcolumns: [
        { field: "id", title: "S.No" },
        { field: "fileName", title: "File Name" },
        { field: "fileUrl", title: "File URL" },
        { field: "fileType", title: "File Type" },

        { cell: fileUploadCell, title: "Actions", width: "300px" },
      ],
      columns: [
        { field: "imei", title: "IMEI Number" },
        { field: "startDate", title: "Start Date" },
        { field: "endDate", title: "End Date" },
      ],
      fuelTypes: [
        { name: "Petrol", id: "P" },
        { name: "Diesel", id: "D" },
        { name: "Electric", id: "E" },
        { name: "LPG", id: "L" },
      ],

      template:
        "<span class='k-progress'></span>" +
        "<div class='file-wrapper'>" +
        "<span class='file-icon img-file'></span>" +
        "<h4 class='file-heading file-name-heading'>Name: #=name#</h4>" +
        "<h4 class='file-heading file-size-heading'>Size: #=size# bytes</h4>" +
        "<strong class='k-upload-status'>" +
        "<button type='button' " +
        "class='k-upload-action'></button>" +
        "<button type='button' class='k-upload-action'></button>" +
        "</strong>" +
        "</div>",
    };
  },
  computed: {
    ...mapState({
      schema: () => [],
    }),
    ...mapGetters(["getSpeedLimit"]),
  },
  created() {
    this.getVehicle();
    this.getDataOnload();
  },
  mounted() {
    this.getVehicle();
    this.expandPanel();

    this.vehicleSpeedLimit = {}; // resetting values
    this.vehicleTypes = this.$store.getters["getVehicleTypes"].map((type) => {
      return {
        ...type,
        displayName: type.name + ` (${type.type})`,
      };
    });

    if (this.$route.params.update) {
      const dataItem = this.$route.params.dataItem;
      this.vehicleSpeedLimit = this.$route.params.dataItem;
      this.vehicleTypeId = this.vehicleTypes.find((vt) => dataItem.vehicleTypeId == vt.id);
      this.highSpeed = dataItem.highSpeed;
      this.safeSpeed = dataItem.safeSpeed;
    }
  },

  methods: {
    goToListPage: function () {
      // this.$store.commit("vehicle/clearFields");
      // this.$store.commit("vehicle/cancel");
      this.$router.push({ name: "vehicle-speed-limit" });
    },
    async getVehicle() {
      this.vehiclelist = this.$store.getters["vehicle/vehicleData"];
    },
    changeType() {},
    changeDriverType() {
      this.driverVal = this.vehicleData.driverID;
    },
    async getDataOnload() {
      await this.$store.dispatch("vehicle/getColumn");
    },
    resetData: function () {
      this.vehicleData = {};
    },
    validation (data) {
      if(!this.$route.params.update) {
        const isPresent = this.getSpeedLimit.find((sl) => sl.vehicleType.id == data.vehicleTypeId.id);
        if (isPresent){ 
          notifyWarn('Vehicle Type already present in Speed limits');
          return false; 
        }
      }
      if (data.highSpeed <= data.safeSpeed) {
        notifyWarn('High Speed should not be lesser than Safespeed');
        return false;
      }
      return true;
    },
    addVehicleSpeedLimit: function () {
      const data ={
        vehicleTypeId : this.vehicleTypeId,
        highSpeed: parseInt(this.highSpeed),
        safeSpeed: parseInt(this.safeSpeed),
      }
      if (!this.validation(data)) return false;
      // TODO remove the below validation
      if (
        data.vehicleTypeId &&
        data.highSpeed &&
        data.safeSpeed
      ) {
        let payload = {
          ...data,
          vehicleTypeId: data.vehicleTypeId.id
        };
        if (!this.$route.params.update) {
          this.$store
            .dispatch("settings/addSpeedLimit", payload)
            .then(() => {
              this.goToListPage();
              this.resetData();
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          payload.id = this.vehicleSpeedLimit.id;
          this.$store
            .dispatch("settings/updateSpeedLimit", {
              data: payload,
            })
            .then(() => {
              this.goToListPage();
            })
            .catch((err) => {
              notifyError(err.response.data.message);
            })
            .finally(() => this.resetData());
        }
      } else {
        console.log("validation failing");
      }
    },

    setup: function () {
      return {
        rules: {
          getVehicle(input) {
            if (input.is("[name='Vehicle Type']") && input.val() == "") {
              return false;
            }

            return true;
          },
          getHighSpeed(input) {
            if (input.is("[name='High Speed']") && input.val() == "") {
              return false;
            }
            return true;
          },
          getSafeSpeed(input) {
            if (input.is("[name='Safe Speed']") && input.val() == "") {
              return false;
            }
            return true;
          },
        },
        messages: {
          getVehicle: "Vehicle Type is required",
          getHighSpeed: "High Speed is required",
          getSafeSpeed: "Safe Speed is required",
        },
      };
    },
    expandPanel() {
      $("#panelbar").kendoPanelBar();
      var panelBar = $("#panelbar").data("kendoPanelBar");
      panelBar.expand($("#item1"));

      if (this.schema.length != 0) {
        $("#panelbar3").kendoPanelBar();
        var panelBar3 = $("#panelbar3").data("kendoPanelBar");
        panelBar3.expand($("#item3"));
      }
    },
  },
  async beforeMount() {
  },
};
</script>
<style>
.file-icon {
  display: inline-block;
  float: left;
  width: 48px;
  height: 48px;
  margin-left: 10px;
  margin-top: 13.5px;
}

.img-file {
  background-image: url(https://demos.telerik.com/kendo-ui/content/web/upload/jpg.png);
}

.file-heading {
  font-family: Arial;
  font-size: 1.1em;
  display: inline-block;
  float: left;
  width: 60%;
  margin: 0 0 0 20px;
  height: 25px;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.file-name-heading {
  font-weight: bold;
  margin-top: 20px;
}

.file-size-heading {
  font-weight: normal;
  font-style: italic;
}

li.k-file div.file-wrapper {
  position: relative;
  height: 75px;
}
</style>
